import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';
import { Form } from 'semantic-ui-react';

import { SCHOOL_CALENDAR_FORM_NAME } from 'Common/FormEnum';
import { CalenderInfoFields } from './CalendarInfoFields';
import { SchoolCalendarFieldEnum as Fields } from 'Common/FieldEnum';
import { addOperationalDays } from 'Common/GeneralHelper';
import { shouldUpdateMbeDate } from '../helpers';

class SchoolCalendarForm extends Component {
  componentDidUpdate(prevProps) {
    const { change, formValues, exceptions } = this.props;

    if (
      !formValues[Fields.MbeEnabled] &&
      prevProps.formValues[Fields.MbeEnabled]
    ) {
      change(Fields.MbeOperationalDays, '');
      change(Fields.MealExpirationDT, null);
    }

    if (
      shouldUpdateMbeDate(
        formValues,
        prevProps.formValues,
        exceptions,
        prevProps.exceptions
      )
    ) {
      change(
        Fields.MealExpirationDT,
        addOperationalDays(
          formValues[Fields.FirstDayDT],
          formValues[Fields.MbeOperationalDays],
          exceptions,
          'MM/DD/YYYY'
        )
      );
    }
  }

  render() {
    const { onSubmit, formValues } = this.props;

    return (
      <Form onSubmit={onSubmit}>
        <CalenderInfoFields formValues={formValues} />
      </Form>
    );
  }
}

const mapStateToProps = state => {
  const formValues = getFormValues(SCHOOL_CALENDAR_FORM_NAME)(state);

  return {
    formValues,
  };
};

SchoolCalendarForm = connect(mapStateToProps)(SchoolCalendarForm);

export default reduxForm({
  form: SCHOOL_CALENDAR_FORM_NAME,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: true,
})(SchoolCalendarForm);



// WEBPACK FOOTER //
// ./src/pages/schoolcalendar/components/SchoolCalendarForm.js